const Share = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 21 20"
		fill="none"
		{...props}
	>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M4 10 1.27 1.125A59.769 59.769 0 0 1 19.485 10a59.767 59.767 0 0 1-18.214 8.875L4 10Zm0 0h7.5"
		/>
	</svg>
);
export default Share;
